import React from "react";
import { AffiliateManagement } from "@components/Affiliate";

export default function AffiliateIndex() {
  return <AffiliateManagement />;
}
